import { motion } from 'framer-motion'
import { Smartphone, Zap, Layers, Shield, Check } from 'react-feather'
import './ServiceDetail.css'
import AnimatedBackground from '../common/AnimatedBackground'


export default function MobileDevelopment() {
  const technologies = [
    "React Native", "Flutter", "iOS (Swift)", "Android (Kotlin)",
    "Firebase", "Redux", "GraphQL", "REST APIs"
  ]

  const features = [
    {
      icon: Smartphone,
      title: "Native Apps",
      description: "High-performance native applications for iOS and Android platforms."
    },
    {
      icon: Zap,
      title: "Cross-Platform",
      description: "Cost-effective solutions that work on multiple platforms."
    },
    {
      icon: Layers,
      title: "Custom Features",
      description: "Tailored functionality to meet your specific business needs."
    },
    {
      icon: Shield,
      title: "Secure & Reliable",
      description: "Built with security best practices and reliable performance."
    }
  ]

  return (
    <section className="service-detail-section">
      <AnimatedBackground text="" />
      <div className="service-detail-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="service-detail-header"
        >
          <h1>Mobile <span className="gradient-text">Development</span></h1>
          <p>Building powerful mobile experiences for iOS and Android</p>
        </motion.div>

        <div className="service-content">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="service-description"
          >
            <h2>What We Offer</h2>
            <p>
              Our mobile development team creates stunning, high-performance 
              applications that engage users and drive business growth. We specialize 
              in both native and cross-platform development, ensuring your app 
              reaches the widest possible audience while maintaining excellent 
              performance and user experience.
            </p>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                  className="feature-card"
                >
                  <Icon className="feature-icon" />
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </motion.div>
              )
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="technologies-section"
          >
            <h2>Technologies We Use</h2>
            <div className="technologies-grid">
              {technologies.map((tech, index) => (
                <div key={tech} className="technology-item">
                  <Check className="check-icon" />
                  <span>{tech}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="cta-section"
          >
            <h2>Ready to Build Your Mobile App?</h2>
            <p>Let's discuss how we can help bring your app idea to life.</p>
            <a href="/contact" className="cta-button">
              Get in Touch
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

